import { List } from 'immutable'
import 'intersection-observer'
import * as React from "react"
import { InView } from 'react-intersection-observer'
import { IOWidget, Updater, fromJSX, } from "widgets-for-react"
import { Link } from "../../../../cms/blocks/types.gen"
import { cleanMultipleHttps, getClassName } from "../../../../cms/blocks/utils.gen"
import { blockInviewHandler } from "../../../../drupal/rendering/inview_utils.mod"
import { ParsedMediaImage } from "../../../../drupal/types_and_parser/types"
import { CMSState } from '../../../drupalPage/state'
import { UpdateItemProps, UpdatesBlock } from "./latestUpdates"

export type latestUpdatesBlockProps = {
  index: number
  field_title: string
  field_latest_update_item: List<latestUpdateItemBlockProps>
  inview?: {
    threshold?: number
    triggerOnce?: boolean
  }
}

export type latestUpdateItemBlockProps = {
  field_label: string
  field_image?: ParsedMediaImage
  field_link: Link
}

export type latestUpdatesBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  footer_classname: string
  author_classname: string
  clickable_classname: string
  visual_classname: string
  image_classname: string
}>

export function latestUpdatesBlock(
  props: latestUpdatesBlockProps,
  options?: { style: latestUpdatesBlockStyle; key?: string }
): IOWidget<CMSState, Updater<CMSState>> {
  return (cmsState: CMSState) =>
    fromJSX(
      _ => {
        return (
          <InView
            as="section"
            onChange={(inView) => blockInviewHandler('latestUpdates', inView, `io-${options && options.key ? options.key : props.index}`, getClassName(options, "inview_classname", "inview"))}
            triggerOnce={props.inview && props.inview.triggerOnce ? props.inview.triggerOnce : false}
            threshold={props.inview && props.inview.threshold ? props.inview.threshold : 0.1}
            id={`io-${options && options.key ? options.key : props.index}`}
            className={"container-fluid bg-light my-5"}
            key={options && options.key ? options.key : `block-${props.index}`}
          >
            {UpdatesBlock(
              {
                isStyleguide: false,
                title: props.field_title,
                items: props.field_latest_update_item
                  .map((e, i) =>
                    (
                      {
                        title: e!.field_link.title,
                        category: e!.field_label,
                        link: cleanMultipleHttps(e!.field_link.url),
                        field_image: e!.field_image,
                      }
                    ) as UpdateItemProps
                  ).toArray(),
              }
            )}
          </InView>
        )
      },
    )
}
